import { Card, Skeleton } from "@mantine/core";
import React from "react";

export default function SingleCardExpertTestimonialSkeleton() {
  return (
    <Card
      padding="md"
      className="sm:w-[363px] sm:h-[214px] p-[25px] flex flex-col justify-between"
      radius="md"
    >
      <Skeleton height={72} width={313} />
      <div className="mt-[13px] flex items-center">
        <Skeleton height={60} width={60} className="rounded-full" />
        <div className="flex flex-col justify-center ms-3">
          <Skeleton height={25} width={107} className="rounded" />
          <Skeleton height={18} width={106} className="mt-2" />
        </div>
      </div>
    </Card>
  );
}
